module.exports = __webpack_public_path__ + "f9d71b8272f0d0fbc4c11ca5726c7a47.MP3";